import { extensions } from 'src/environments/extensions';
import { DEBOUNCE_TIME } from 'src/environments/timing';
import {
    date,
    time
} from 'src/environments/date/date';
import { tinymce } from 'src/environments/tinymce';
import { numbers } from 'src/environments/numbers';
import { constants } from 'src/environments/constants';

export const environment = {
    production: true,
    graphql: 'https://expertapi2.123cegestionplus.com/graphql',
    printApi: 'https://printingapi.123cegestionplus.com',
    debounceTime: DEBOUNCE_TIME,
    date,
    time,
    extensions,
    tinymce,
    numbers,
    hashVersion: '__hashVersion__',
    constants
};
